import {route, string, union} from 'react-router-typesafe-routes';

export const todosRoutesPath = route({
  children: {
    availability: route({
      path: 'my-calendar',
      searchParams: {
        // should open schedule modal
        os: union(['1', '0']),
      },
    }),
    event: route({
      path: 'event/:eventId',
    }),
    /**
     * @deprecated
     * Use event route instead
     */
    eventPage: route({
      path: 'event-page/:eventId',
    }),
    todos: route({
      path: 'to-dos',
      searchParams: {
        cs: string(),
        t: union(['all', 'conference', 'task']),
      },
    }),
  },
});
